import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=149aa29b&scoped=true"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"
import style0 from "./UserData.vue?vue&type=style&index=0&id=149aa29b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149aa29b",
  null
  
)

export default component.exports